/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFSecReviewBrandFinderDetails
 */
export interface CRSFSecReviewBrandFinderDetails {
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewBrandFinderDetails
     */
    domain: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewBrandFinderDetails
     */
    explanation?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewBrandFinderDetails
     */
    reason: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewBrandFinderDetails
     */
    sources?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewBrandFinderDetails
     */
    target: string;
}

/**
 * Check if a given object implements the CRSFSecReviewBrandFinderDetails interface.
 */
export function instanceOfCRSFSecReviewBrandFinderDetails(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "domain" in value;
    isInstance = isInstance && "reason" in value;
    isInstance = isInstance && "target" in value;

    return isInstance;
}

export function CRSFSecReviewBrandFinderDetailsFromJSON(json: any): CRSFSecReviewBrandFinderDetails {
    return CRSFSecReviewBrandFinderDetailsFromJSONTyped(json, false);
}

export function CRSFSecReviewBrandFinderDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewBrandFinderDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'domain': json['domain'],
        'explanation': !exists(json, 'explanation') ? undefined : json['explanation'],
        'reason': json['reason'],
        'sources': !exists(json, 'sources') ? undefined : json['sources'],
        'target': json['target'],
    };
}

export function CRSFSecReviewBrandFinderDetailsToJSON(value?: CRSFSecReviewBrandFinderDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'domain': value.domain,
        'explanation': value.explanation,
        'reason': value.reason,
        'sources': value.sources,
        'target': value.target,
    };
}

